var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingFillForm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6838 2.94904C5.09375 2.94904 4.61543 3.42737 4.61543 4.01742V15.9832C4.61543 16.5733 5.09375 17.0516 5.6838 17.0516H14.2308C14.8209 17.0516 15.2992 16.5733 15.2992 15.9832V7.79025C15.2992 7.73358 15.2767 7.67923 15.2366 7.63916L10.6091 3.01163C10.569 2.97156 10.5146 2.94904 10.458 2.94904H5.6838ZM3.33337 4.01742C3.33337 2.71931 4.3857 1.66699 5.6838 1.66699H10.458C10.8547 1.66699 11.2351 1.82458 11.5156 2.10508L16.1432 6.73261C16.4237 7.01312 16.5812 7.39356 16.5812 7.79025V15.9832C16.5812 17.2813 15.5289 18.3337 14.2308 18.3337H5.6838C4.3857 18.3337 3.33337 17.2813 3.33337 15.9832V4.01742ZM6.75218 10.0003C6.75218 9.6463 7.03917 9.3593 7.3932 9.3593H12.5214C12.8754 9.3593 13.1624 9.6463 13.1624 10.0003C13.1624 10.3544 12.8754 10.6414 12.5214 10.6414H7.3932C7.03917 10.6414 6.75218 10.3544 6.75218 10.0003ZM6.75218 13.4191C6.75218 13.0651 7.03917 12.7781 7.3932 12.7781H12.5214C12.8754 12.7781 13.1624 13.0651 13.1624 13.4191C13.1624 13.7732 12.8754 14.0602 12.5214 14.0602H7.3932C7.03917 14.0602 6.75218 13.7732 6.75218 13.4191Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingFillForm);
export default __webpack_public_path__ + "static/media/onboarding-fill-form.16b52f5f82704079ee246944c5abdc0c.svg";
export { ForwardRef as ReactComponent };